import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

interface UtilityUsernameProps extends InputComponentProps {
  utilityName?: string;
}

export const UtilityUsername = ({ utilityName, ...props }: UtilityUsernameProps) => {
  const validate = ({ value }) => {
    if (!value.length) return 'Please enter a username';
    return true;
  };

  return (
    <ValidatingInput
      autoComplete="username"
      label={utilityName ? `Username for ${utilityName}` : 'Username'}
      name="utilityUsername"
      placeholder="Enter your username"
      validate={validate}
      {...props}
    />
  );
};
